
import {
  StyledTeamMember,
  StyledTeamMemberCaption,
  StyledTeamMemberImg,
  StyledTeamMemberTitle,
} from './TeamMember.styled';

const TeamMember = ({ members }) => (
  <StyledTeamMember>
    <StyledTeamMemberImg src={members.img} alt="" />
    <StyledTeamMemberCaption>
      <StyledTeamMemberTitle>{members.fullName}</StyledTeamMemberTitle>
      <p>{members.desc}</p>
    </StyledTeamMemberCaption>
  </StyledTeamMember>
);

export default TeamMember;
